import{ useEffect, useState, useMemo } from "react";
import {
    FormControlLabel, Checkbox, List, ListItem, ListItemText, IconButton, Accordion, AccordionSummary, AccordionDetails, Container,
    TextField, Button, Grid, Box, Select, MenuItem, Typography, FormControl, InputLabel, Tooltip, Fab, Autocomplete, Divider
} from "@mui/material";
import { UrlApi } from "../../../../../services/apirest";
import { grey } from "@mui/material/colors";
import { getData, } from "../../../../../services/library";
import AddIcon from "@mui/icons-material/Add";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BarraDatosPedidoList from "./BarraDatosPedidosList";
import VerificacionDomicilio from "./Mapas/VerificacionDomicilio";
import FormTanqueRapido from "./FormTanqueRapido";
import { v4 as uuidv4 } from "uuid";
import ModalRepetido2 from "./ModalRepetido2";
import moment from "moment";
import DialogPHVencida from "./DialogPHVencida";
import AlertWButtonCapYPH from "./AlertWButtonCapYPH";
import Sin_cuit from "./Sin_cuit";
import ModalAddlistaprecio from "./ModalAddlistaprecio";
import AddPrecioEspecialDireccion from "../../../../lista_precios/granel/preciosEspeciales/AddPrecioEspecialDireccion";
import Alerta from "../../../../Alerta";
import Notify from "../../../../Notify";
import { logEventos } from "../../../../../services/services";
import { Save } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModalCapacidades from "./ModalCapacidades";
import Title from "../../../../Title";

function AddPedidosList(props) {
    const [uuidinicial, setUuid] = useState(uuidv4());
    const [datosPedido, setDatosPedido] = useState([
        {
            id_origen: 30,
            cantidad: "",
            porcentaje: "",
            pesos: "",
            id_estado: "",
            id_cliente: props.datosCli && props.datosCli.id,
            id_direccionentrega: "",
            id_tanque: "",
            fecha_requerida: "",
            observaciones: null,
            usuario: localStorage.getItem("user"),
            kgacargar: "",
            ltsacargar: "", // Nuevo campo para litros
            prioritario: 0,
            fecha_probable_entrega: "",
            nro_reparto: "",
            tqobat: "",
            id_bateria: "",
            idsucursal_atiende: "",
            precio_iva: "",
            precio_siniva: "",
            uni_fact: "",
            uuid_pedido: uuidinicial,
            mantiene_precio: null,
            ltsacargar: ""
        },
    ]);

    const [observaciones, setObservaciones] = useState([{
        observaciones_pedido: null,
        uuid_pedido: uuidinicial,
        usuario: localStorage.getItem('user')
    }]);
    const [disCant, setDisCant] = useState(false);
    const [disPorc, setDisPorc] = useState(false);
    const [disbtn, setdisbtn] = useState(false);
    const [PHVencida, setPHVencida] = useState(false);
    const [capMaxKg, setCapMaxKg] = useState(null);
    const [noPH, setNoPH] = useState(false);
    const [tksSinCap, setTksSinCap] = useState([]);
    const [tksSinPHOVencida, setTksSinPHOVencida] = useState([]);
    const [direcciones, setDirecciones] = useState([{}]);
    const [tanques, setTanques] = useState([{}]);
    const [sucursales, setSucursales] = useState([{}]);
    const [kgCarga, setkgCarga] = useState(null);
    const [expandedAccordion, setExpandedAccordion] = useState(0);
    let observaciones_pesada = "INGRESAR LOS KILOS POR PESADA";
    const [tanqueConPHVencida, setTanqueConPHVencida] = useState(null);
    const [showModalMapa, setShowModalMapa] = useState(false);
    const [direccionSeleccionada, setDireccionSeleccionada] = useState([{}]);
    const [showAltaTanque, setShowAltaTanque] = useState(false);
    const [tanquesxbat, setTanquesxbat] = useState({});
    const [pedidoRepetido, setPedidoRepetido] = useState();
    const [precio, setPrecio] = useState([]);
    const [precioIva, setPrecioIva] = useState(0);
    const [precionormal, setPrecioNormal] = useState(0);
    const [dialogPrecioEspecial, setdialogPrecioEspecial] = useState(false);
    const [dialogListaPrecio, setdialogListaPrecio] = useState(false);
    const [cambieDir, setCambieDir] = useState(false);
    const [cambieTanque, setcambieTanque] = useState(false);
    const [dialogPrecioEspecialCerrado, setDialogPrecioEspecialCerrado] = useState(false);
    const [dialogListaPrecioCerrado, setDialogListaPrecioCerrado] = useState(false);
    const [modalCuit, setmodalCuit] = useState(false);
    const [segmentos, setSegmentos] = useState([]);
    const [segSelected, setSegselectd] = useState(null);
    const [condiciones, setCondiciones] = useState([]);
    const [condSelected, setcondSelected] = useState(null);
    const [direccion, setDireccion] = useState([]);
    const [showModalCap, setShowModalCap] = useState(false);
    const [ultimoPedido, setultimoPedido] = useState([]);
    const [tanqueSel, setTanqueSel] = useState([
        {
            capacidad: "",
            delivery_stop: "",
            id_direccionentrega: "",
            id_tanque: "",
            idbateria: "",
            nro: "",
            nro_serie: "",
            vto_pruebahidraulica: "",
        },
    ]);
    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const obtenerUltimoPedido = (direccion) => {
        getData(`/pedidos/direc/ultimo_registro/${props.datosCli.id}/${direccion}`, setultimoPedido);
    };

    const obtenerDirecciones = () => {
        fetch(UrlApi + `/direccionesentrega/cli/${props.datosCli.id}`)
            .then((res) => res.json())
            .then((data) => {
                setDirecciones(data);
            });
    };

    const getTanques = (valor) => {
        fetch(UrlApi + `/tanques/dirent/${valor}`)
            .then((res) => res.json())
            .then((tanques) => {
                setTanques(tanques);
            })
            .catch((error) => console.error("Error al obtener tanques:", error));
    };

    const obtenerTqXBat = () => {
        const idsBaterias = tanqueSel
            .filter((t) => t.idbateria)
            .map((t) => t.idbateria)
            .join(",");

        if (!idsBaterias) {
            console.warn("No hay tanques con batería seleccionada.");
            return;
        }

        fetch(`${UrlApi}/tanques/bateria/${idsBaterias}`)
            .then((res) => res.json())
            .then((data) => {
                setTanquesxbat(data);
            })
            .catch((error) => console.error("Error al obtener tanques por batería:", error));
    };

    const getPedidoRepetidoBat = () => {
        const req = [];
        const seenCombinations = new Set();

        datosPedido.forEach((pedido) => {
            tanqueSel
                .filter((tanque) => tanque.idbateria)
                .forEach((tanque) => {
                    const combinationKey = `${tanque.idbateria}`;
                    if (seenCombinations.has(combinationKey)) {
                        return;
                    }
                    seenCombinations.add(combinationKey);
                    const url = `${UrlApi}/pedidos/bat/${tanque.idbateria}`;
                    req.push(
                        fetch(url)
                            .then((res) => {
                                if (!res.ok) {
                                    throw new Error(`Error en la petición: ${res.statusText}`);
                                }
                                return res.json();
                            })
                            .then((data) => ({
                                uuid_pedido: pedido.uuid,
                                id_bateria: tanque.idbateria,
                                data,
                            }))
                    );
                });
        });

        Promise.all(req)
            .then((results) => {
                const pedidosData = results
                    .map((result) => result.data)
                    .filter((data) => Array.isArray(data) && data.length > 0)
                    .flat();
                if (pedidosData.length > 0) {
                    setPedidoRepetido(pedidosData);
                }
                // else {
                //     console.log("No hay pedidos repetidos o data vacía");
                // }
            })
            .catch((error) => {
                console.error("Error al obtener pedidos repetidos:", error);
            });
    };

    const checkTq = () => {
        const tanquesConBateria = tanqueSel.filter((t) => t.idbateria);
        if (tanquesConBateria.length > 0) {
            getPedidoRepetidoBat();
            obtenerTqXBat();
        } else {
            const tanques = tanqueSel.filter((t) => t.capacidad);
        }
    };

    const checkBat = () => {
        const today = moment(new Date()).format("YYYY-MM-DD");
        tanquesxbat.map((tanque) => {
            if (!tanque.capacidad || tanque.capacidad === 0) {
                tksSinCap &&
                    !tksSinCap.includes(tanque.nro_serie) &&
                    tksSinCap.push(tanque.nro_serie);
            } else {
                const densidad = props.datosCli.id_empresa === 4
                    ? direccion[0].densidad_autogas
                    : direccion[0].densidad_hipergas;
                setDisCant(false);
                setDisPorc(false);
                setCapMaxKg(tanque.capacidad * 1 * 1000 * 0.85 * densidad);
            }

            if (!tanque.vto_pruebahidraulica || tanque.vto_pruebahidraulica < today) {
                tksSinPHOVencida &&
                    !tksSinPHOVencida.includes(tanque.nro_serie) &&
                    tksSinPHOVencida.push(tanque.nro_serie);
            }
        });
        const densidad = props.datosCli.id_empresa === 4
            ? direccion[0].densidad_autogas
            : direccion[0].densidad_hipergas;

        setCapMaxKg(
            tanquesxbat
                .map((item) => item.capacidad * 1 * 1000 * 0.85 * densidad)
                .reduce((acumulador, valorActual) => acumulador + valorActual, 0)
                .toFixed(2)
        );
    };

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        if (isExpanded) {
            setExpandedAccordion(panel);
        } else {
            setExpandedAccordion(-1);
        }
    };

    const handleAddAccordion = () => {
        agregarNuevoPedido();
        setExpandedAccordion(datosPedido.length);
    };

    const actualizarPedido = (index, campo, valor) => {
        const nuevosDatos = [...datosPedido];
        nuevosDatos[index][campo] = valor === "" ? null : valor;
        setDatosPedido(nuevosDatos);

        if (campo === "id_direccionentrega") {
            if (valor) {
                getTanques(valor);
            } else {
                console.error("La dirección seleccionada es inválida:", valor);
            }
        }
    };

    const actualizarObservaciones = (index, valor) => {
        // console.log("actualizarObservaciones:", { index, valor }); // Añadir para depuración
        const nuevasObservaciones = [...observaciones];
        nuevasObservaciones[index] = {
            ...nuevasObservaciones[index],
            observaciones_pedido: valor === "" ? null : valor,
        };
        setObservaciones(nuevasObservaciones);
    };

    const agregarNuevoPedido = () => {
        const uuid = uuidv4();
        setDatosPedido((prev) => [
            ...prev,
            {
                id_origen: 30,
                cantidad: "",
                porcentaje: "",
                id_estado: "",
                id_cliente: props.datosCli.id,
                id_direccionentrega: "",
                id_tanque: "",
                fecha_requerida: "",
                observaciones: "",
                usuario: localStorage.getItem("user"),
                kgacargar: "",
                ltsacargar: "",
                prioritario: 0,
                fecha_probable_entrega: "",
                nro_reparto: "",
                tqobat: "",
                id_bateria: "",
                idsucursal_atiende: "",
                precio_iva: "",
                precio_siniva: "",
                uni_fact: "",
                uuid_pedido: uuid,
                mantiene_precio: null,
                ltsacargar: ""
            },
        ]);
        setObservaciones((prev) => [
            ...prev,
            {
                observaciones_pedido: "",
                uuid_pedido: uuid,
                usuario: localStorage.getItem("user"),
                activo: 1
            },
        ]);
    };

    const deshacerAlmacenar = (index) => {
        if (datosPedido.length > 1) {
            const values = [...datosPedido];
            values.splice(index, 1);
            setDatosPedido(values);
        } else {
            setDatosPedido([
                {
                    id_origen: 30,
                    cantidad: "",
                    porcentaje: "",
                    pesos: "",
                    id_estado: "",
                    id_cliente: props.datosCli && props.datosCli.id,
                    id_direccionentrega: "",
                    id_tanque: "",
                    fecha_requerida: "",
                    observaciones: null,
                    usuario: localStorage.getItem("user"),
                    kgacargar: "",
                    ltsacargar: "", // Nuevo campo para litros
                    prioritario: 0,
                    fecha_probable_entrega: "",
                    nro_reparto: "",
                    tqobat: "",
                    id_bateria: "",
                    idsucursal_atiende: "",
                    precio_iva: "",
                    precio_siniva: "",
                    uni_fact: "",
                    uuid_pedido: null,
                    mantiene_precio: null,
                    ltsacargar: ""
                },
            ]);
        }
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
    };

    const handleVerificarDomicilio = (idDireccion) => {
        const direccion = direcciones.find((dir) => dir.id === idDireccion);
        setDireccionSeleccionada(direccion);
        setShowModalMapa(true);
    };

    const handleAddTanque = (idDireccion, idTanque) => {
        setShowAltaTanque(true);
        const direccion = direcciones.find((dir) => dir.id === idDireccion);
        setDireccionSeleccionada(direccion);
    };

    const calcularKGPorc = (pedido, tanque) => {
        if (!pedido || typeof pedido.porcentaje === "undefined") {
            console.error("El pedido o su porcentaje no es válido");
            return { kg: "", lts: "" };
        }

        if (!direccion || !direccion.length) {
            console.error("La dirección no está definida o está vacía");
            return { kg: "", lts: "" };
        }

        const densidad = props.datosCli.id_empresa === 4
            ? direccion[0].densidad_autogas
            : direccion[0].densidad_hipergas;

        if (!densidad) {
            console.error("La densidad no está definida correctamente");
            return { kg: "", lts: "" };
        }

        const porcentaje = parseFloat(pedido.porcentaje) / 100;

        if (isNaN(porcentaje) || porcentaje < 0 || porcentaje > 1) {
            console.error("El porcentaje no es válido:", pedido.porcentaje);
            return { kg: "", lts: "" };
        }

        if (tanque && tanque.idbateria) {
            if (!tanquesxbat || tanquesxbat.length === 0) {
                console.error("No se ha definido o no hay tanques en la batería.");
                return { kg: "", lts: "" };
            }

            const capacidades = tanquesxbat
                .filter((item) => item.id_bateria === tanque.idbateria)
                .reduce(
                    (acumulador, item) => {

                        // const capacidadUtil = item.capacidad * 1000 * 0.85;
                        // const capacidadConPorcentaje = capacidadUtil - capacidadUtil * porcentaje;
                        // const capacidadKg = capacidadConPorcentaje * densidad;
                        // const capacidadLts = capacidadConPorcentaje;

                          const capacidadTotalLts = tanque.capacidad * 1000;
                            const contenidoActualLts = capacidadTotalLts * porcentaje;
                            const contenidoMaximoLts = capacidadTotalLts * 0.85;
                            const contenidoALlenarLts = contenidoMaximoLts - contenidoActualLts; 
                            const contenidoALlenarKgs = contenidoALlenarLts * densidad;



                        return {
                            // kg: acumulador.kg + capacidadKg,
                            // lts: acumulador.lts + capacidadLts,
                            kg: acumulador.kg + contenidoALlenarKgs,
                            lts: acumulador.lts + contenidoALlenarLts,
                        };
                    },
                    { kg: 0, lts: 0 }
                );

            return {
                kg: capacidades.kg.toFixed(0),
                lts: capacidades.lts.toFixed(0),
            };
        } else if (tanque && !tanque.idbateria) {
            // const capacidadUtil = tanque.capacidad * 1000 * 0.85;
            // const capacidadConPorcentaje = capacidadUtil - capacidadUtil * porcentaje;
            // const capacidadKg = capacidadConPorcentaje * densidad;
            // const capacidadLts = capacidadConPorcentaje;

            const capacidadTotalLts = tanque.capacidad * 1000;
            const contenidoActualLts = capacidadTotalLts * porcentaje;
            const contenidoMaximoLts = capacidadTotalLts * 0.85;
            const contenidoALlenarLts = contenidoMaximoLts - contenidoActualLts; 
            const contenidoALlenarKgs = contenidoALlenarLts * densidad;

            return {
                // kg: capacidadKg.toFixed(0),
                // lts: capacidadLts.toFixed(0),
                kg: contenidoALlenarKgs.toFixed(0),
                lts: contenidoALlenarLts.toFixed(0),
                
            };
        }

        return { kg: "", lts: "" };
    };

    const handleCantidadChange = (index, field, value) => {
        const nuevosDatos = [...datosPedido];
        const pedidoActual = { ...nuevosDatos[index] };

        const densidad = props.datosCli.id_empresa === 4
            ? direccion[0]?.densidad_autogas
            : direccion[0]?.densidad_hipergas;

        if (!densidad) {
            console.error("Densidad no definida");
            return;
        }

        if (field === "kg") {
            const kg = parseFloat(value) || 0;
            const lts = kg / densidad;
            pedidoActual.cantidad = value;
            pedidoActual.kgacargar = value;
            pedidoActual.ltsacargar = lts ? lts : "";

            if (value === "") {
                pedidoActual.porcentaje = "";
            } else {
                // pedidoActual.porcentaje = calcularPorcentajeDesdeCantidad(kg, tanqueSel[index], "kg");
            }
        }
        else if (field === "lts") {
            const lts = parseFloat(value) || 0;
            const kg = lts * densidad;
            pedidoActual.ltsacargar = value;
            pedidoActual.cantidad = kg ? kg : "";
            pedidoActual.kgacargar = kg ? kg : "";

            if (value === "") {
                pedidoActual.porcentaje = "";
            } else {
                // pedidoActual.porcentaje = calcularPorcentajeDesdeCantidad(lts, tanqueSel[index], "lts");
            }

        } else if (field === "porcentaje") {
            pedidoActual.porcentaje = value;
            const resultado = calcularKGPorc({ porcentaje: value }, tanqueSel[index]);
            pedidoActual.kgacargar = resultado.kg || "";
            pedidoActual.ltsacargar = resultado.lts || "";
            pedidoActual.cantidad = resultado.kg || "";
            if (value === "") {
                pedidoActual.cantidad = "";
                pedidoActual.ltsacargar = "";
            }
        }

        nuevosDatos[index] = pedidoActual;
        setDatosPedido(nuevosDatos);
    };

    const guardarTanqueSeleccionado = (index, idTanque) => {
        const tanqueSeleccionado = tanques.find((tanque) => tanque.id_tanque === idTanque);

        if (tanqueSeleccionado) {
            setTanqueSel((prev) => {
                const updatedTanques = Array.isArray(prev) ? [...prev] : [];
                if (updatedTanques[index]) {
                    updatedTanques[index] = {
                        ...updatedTanques[index],
                        capacidad: tanqueSeleccionado.capacidad || "",
                        delivery_stop: tanqueSeleccionado.delivery_stop || "",
                        id_direccionentrega: tanqueSeleccionado.id_direccionentrega,
                        id_tanque: tanqueSeleccionado.id_tanque,
                        idbateria: tanqueSeleccionado.idbateria || "",
                        nro: tanqueSeleccionado.nro || "",
                        nro_serie: tanqueSeleccionado.nro_serie || "",
                        vto_pruebahidraulica: tanqueSeleccionado.vto_pruebahidraulica || "",
                    };

                    if (tanqueSeleccionado.cantidad) {
                        const densidad = props.datosCli.id_empresa === 4
                            ? direccion[0].densidad_autogas
                            : direccion[0].densidad_hipergas;
                        const capacidadMaxima = tanqueSeleccionado.capacidad * 1000 * 0.85 * densidad;
                        updatedTanques[index].capacidad_maxima = capacidadMaxima;
                    } else {
                        setDisCant(false);
                        setDisPorc(true);
                    }
                } else {
                    const nuevoTanque = {
                        capacidad: tanqueSeleccionado.capacidad || "",
                        delivery_stop: tanqueSeleccionado.delivery_stop || "",
                        id_direccionentrega: tanqueSeleccionado.id_direccionentrega,
                        id_tanque: tanqueSeleccionado.id_tanque,
                        idbateria: tanqueSeleccionado.idbateria || "",
                        nro: tanqueSeleccionado.nro || "",
                        nro_serie: tanqueSeleccionado.nro_serie || "",
                        vto_pruebahidraulica: tanqueSeleccionado.vto_pruebahidraulica || "",
                    };

                    if (tanqueSeleccionado.cantidad) {
                        const densidad = props.datosCli.id_empresa === 4
                            ? direccion[0].densidad_autogas
                            : direccion[0].densidad_hipergas;
                        const capacidadMaxima = tanqueSeleccionado.capacidad * 1000 * 0.85 * densidad;
                        nuevoTanque.capacidad_maxima = capacidadMaxima;
                    }

                    updatedTanques.push(nuevoTanque);
                }

                return updatedTanques;
            });

            const today = moment().format("YYYY-MM-DD");
            if (tanqueSeleccionado.vto_pruebahidraulica) {
                if (tanqueSeleccionado.vto_pruebahidraulica < today) {
                    setPHVencida(true);
                    setTanqueConPHVencida(tanqueSeleccionado);
                }
            } else {
                setNoPH(true);
                setTanqueConPHVencida(tanqueSeleccionado);
            }

            if (!tanqueSeleccionado.capacidad || tanqueSeleccionado.capacidad === 0) {
                setDisCant(false);
                setDisPorc(true);
            } else {
                const densidad = props.datosCli.id_empresa === 4
                    ? direccion[0].densidad_autogas
                    : direccion[0].densidad_hipergas;
                const capacidadMaxKg = tanqueSeleccionado.capacidad * 1000 * 0.85 * densidad;
                setCapMaxKg(capacidadMaxKg);
                setDisCant(false);
                setDisPorc(false);
            }

            datosPedido.forEach((pedido) => {
                if (!pedido.id_cliente || !pedido.id_direccionentrega) {
                    console.error("Datos de dirección incompletos:", pedido);
                    return;
                }

                const url = `${UrlApi}/pedidos/repe/${pedido.id_cliente}/${pedido.id_direccionentrega}/${tanqueSeleccionado.id_tanque}`;
                fetch(url)
                    .then((res) => {
                        if (!res.ok) {
                            throw new Error(`Error en la petición: ${res.statusText}`);
                        }
                        return res.json();
                    })
                    .then((data) => {
                        if (Array.isArray(data) && data.length > 0) {
                            setPedidoRepetido(data);
                        }
                    })
                    .catch((error) => {
                        console.error("Error al verificar pedido repetido:", error);
                    });
            });
        }
    };

    const getPrecios = async (idDireccion) => {
        if (!direccion || !segSelected || !direccionSeleccionada || !props.datosCli.id_empresa) return;

        try {
            let url;
            if (props.datosCli.precio_especial === 1) {
                url = `/precios_especiales/vigente/cliente/${props.datosCli.id}`;
                const response = await fetch(UrlApi + url);
                const data = await response.json();
                // console.log("data", data);

                setPrecio(data);
                if (data.length === 0) {
                    setdialogPrecioEspecial(true);
                }
            } else {
                url = `/lista_precios/fechavigente/${props.datosCli.id_empresa}/${props.datosCli.id_sucursal}/${segSelected.id}/${direccion[0]?.id_producto}`;
                const response = await fetch(UrlApi + url);
                const data = await response.json();
                setPrecio(data);
                // console.log("datra", data);

                if (data.length === 0) {
                    setdialogListaPrecio(true);
                }
            }
        } catch (error) {
            console.error("Error obteniendo precios:", error);
        }
    };

    const setearValores = async () => {
        if (precio) {
            if (props.datosCli.unidad_fact === 216) {
                let precio_sinIva = precio[0]?.precio_litro_sin_iva ?? precio[0]?.lt_sin_iva;
                let precio_conIva = precio[0]?.precio_litro_con_iva ?? precio[0]?.lt_con_iva;
                setPrecioIva(precio_conIva);
                setPrecioNormal(precio_sinIva);
            } else if (props.datosCli.unidad_fact === 215) {
                let precio_sinIva = precio[0]?.precio_kilo_sin_iva ?? precio[0]?.kg_sin_iva;
                let precio_conIva = precio[0]?.precio_kilo_con_iva ?? precio[0]?.kg_con_iva;
                setPrecioIva(precio_conIva);
                setPrecioNormal(precio_sinIva);
            }
        }
    };

    const onCloseDialog = () => {
        setDialogPrecioEspecialCerrado(true);
        setdialogPrecioEspecial(false);
    };

    const handleCloseDialogListaPrecio = () => {
        setDialogListaPrecioCerrado(true);
        setdialogListaPrecio(false);
    };

    useEffect(() => {
        const cuit = props.datosCli?.cuit?.trim() || "";
        const isInvalidCuit = /^[-\s]*$/.test(cuit);
        if (!cuit || isInvalidCuit) {
            setmodalCuit(true);
        }
    }, [props.datosCli]);

    const selectedSegmento = useMemo(() => {
        return segmentos ? segmentos.find((s) => s.id === props.datosCli.id_segmento) : null;
    }, [props.datosCli.id_segmento, segmentos]);

    const selectedCond = useMemo(() => {
        return condiciones ? condiciones.find((c) => c.id === props.datosCli.id_condicionpago) : null;
    }, [props.datosCli.id_condicionpago, condiciones]);

    useEffect(() => {
        if (selectedSegmento) {
            setSegselectd(selectedSegmento);
        }
    }, [selectedSegmento]);

    useEffect(() => {
        if (selectedCond) {
            setcondSelected(selectedCond);
        }
    }, [selectedCond]);

    useEffect(() => {
        if (direccion && direccion.length) {
            getPrecios();
        }
    }, [direccion, cambieDir, cambieTanque,]);

    useEffect(() => {
        precio && setearValores();
    }, [direcciones, precio]);

    useEffect(() => {
        fetch(UrlApi + "/segmentos")
            .then((data) => data.json())
            .then((data) => setSegmentos(data));

        fetch(UrlApi + "/condicion_pago")
            .then((data) => data.json())
            .then((data) => setCondiciones(data));


    }, []);

    useEffect(() => {
        tanquesxbat && tanquesxbat.length > 0 && checkBat();
    }, [tanquesxbat]);

    useEffect(() => {
        getData("/sucursales/tipoPlanta", setSucursales);
    }, [props.datosCli.id]);

    useEffect(() => {
        setkgCarga(null);
        const hayValores = Object.values(tanqueSel).some((value) => !!value);
        if (hayValores) {
            checkTq();
        }
    }, [tanqueSel]);

    useEffect(() => {
        getData("/direccionesentrega/xcliente/" + props.datosCli.id, setDireccion);
        obtenerDirecciones();
    }, []);

    const armaBodyObsPedido=(pedido)=>{
        const allObservaciones=[];

        if(!!pedido.observaciones){
            allObservaciones.push({
                observacion:pedido.observaciones,
                para_chofer:1, 
                usuario:localStorage.getItem("user"),
                fija:1
    
            })
        }
        return allObservaciones;
    }

    const guardarPedidos = async (e) => {
        e.preventDefault();
        logEventos("Guardar pedidos", "Granel", "Cargar pedidos", localStorage.getItem("user"));
        setdisbtn(true);

        try {
            // Preparar el cuerpo de la solicitud para los pedidos
            const reqBody = {
                pedidosList: datosPedido.map((pedido) => ({
                    id_origen: pedido.id_origen,
                    cantidad: pedido.cantidad ? parseFloat(pedido.cantidad) : null,
                    porcentaje: pedido.porcentaje ? parseFloat(pedido.porcentaje) : null,
                    pesos: pedido.pesos ? parseFloat(pedido.pesos) : null,
                    id_estado: 19,
                    id_cliente: props.datosCli?.id || null,
                    id_direccionentrega: pedido.id_direccionentrega,
                    id_tanque: pedido.id_tanque,
                    fecha_requerida: pedido.fecha_requerida || null,
                    observaciones:armaBodyObsPedido(pedido),
                    // observaciones: {
                    //     ...pedido.observaciones&&{
                    //         observacion:pedido.observaciones || ""
                    //     }
                    // },
                    // observaciones:
                    //     props.datosCli.pesada_cliente === 1
                    //         ? `${pedido.observaciones || ""} ${observaciones_pesada}`.trim()
                    //         : pedido.observaciones === "" ? null : pedido.observaciones,
                    usuario: localStorage.getItem("user"),
                    kgacargar: pedido.kgacargar ? parseFloat(pedido.kgacargar) : null,
                    prioritario: 0,
                    tqobat: pedido.tqobat || null,
                    id_bateria: pedido.id_bateria || null,
                    idsucursal_atiende: pedido.idsucursal_atiende || null,
                    mantiene_precio: pedido.mantiene_precio || null,
                    uuid_pedido: pedido.uuid_pedido,
                    ltsacargar: pedido.ltsacargar
                })),
            };

            // Enviar la solicitud para guardar los pedidos
            const response = await fetch(UrlApi + "/pedidos/post_lista/post_obs", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(reqBody),
            });

            if (!response.ok) {
                throw new Error(`Error al guardar los pedidos: ${response.statusText}`);
            }

            const pedidosGuardados = await response.json();

            // Verificar la respuesta de la API
            if (pedidosGuardados?.message !== "PEDIDOS GUARDADOS ") {
                console.warn("Respuesta inesperada de la API:", pedidosGuardados);
                setNotificacion({
                    open: true,
                    mensaje: "Pedidos guardados, pero la respuesta de la API no fue la esperada.",
                    severity: "warning",
                    color: "#ff9800",
                });
            }

            // Preparar las observaciones para guardar usando uuid_pedido
            const observacionesBody = observaciones
                .map((obs, index) => {
                    if (obs.observaciones_pedido) {
                        return {
                            uuid_pedido: obs.uuid_pedido,
                            observaciones: obs.observaciones_pedido,
                            usuario: obs.usuario,
                            activo: 1
                        };
                    }
                    return null;
                })
                .filter((obs) => obs !== null);
            if (observacionesBody.length > 0) {
                const observacionesResponse = await fetch(UrlApi + "/observaciones_pedidos/post_lista", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ body: observacionesBody }),  
                });

                if (!observacionesResponse.ok) {
                    throw new Error(`Error al guardar las observaciones: ${observacionesResponse.statusText}`);
                }
                // console.log("Observaciones guardadas exitosamente");
            } else {
                console.log("No hay observaciones válidas para guardar");
            }

            // Notificación de éxito
            setNotificacion({
                open: true,
                mensaje: observacionesBody.length > 0
                    ? "Pedidos y observaciones guardados exitosamente"
                    : "Pedidos guardados, pero no había observaciones internas para guardar",
                severity: "success",
                color: "#4caf50",
            });

            // Resetear el estado
            // const newUuid = uuidv4();
            setDatosPedido([
                {
                    id_origen: 30,
                    cantidad: "",
                    porcentaje: "",
                    pesos: "",
                    id_estado: "",
                    id_cliente: props.datosCli?.id,
                    id_direccionentrega: "",
                    id_tanque: "",
                    fecha_requerida: "",
                    observaciones: "",
                    usuario: localStorage.getItem("user"),
                    kgacargar: "",
                    ltsacargar: "",
                    prioritario: 0,
                    fecha_probable_entrega: "",
                    nro_reparto: "",
                    tqobat: "",
                    id_bateria: "",
                    idsucursal_atiende: "",
                    precio_iva: "",
                    precio_siniva: "",
                    uni_fact: "",
                    uuid_pedido: datosPedido.uuid_pedido,
                    mantiene_precio: null,
                    ltsacargar: ""
                },
            ]);
            setObservaciones([
                {
                    observaciones_pedido: "",
                    uuid_pedido: datosPedido.uuid_pedido,
                    usuario: localStorage.getItem("user"),
                    activo: 1
                },
            ]);
            setdisbtn(false);
            props.addPedido(false);
            props.tabla(true);
        } catch (error) {
            console.error("Error al guardar:", error);
            setNotificacion({
                open: true,
                mensaje: `Error al guardar los pedidos y/o observaciones: ${error.message}`,
                severity: "error",
                color: "#f44336",
            });
            setdisbtn(false);
        }
    };

    const handleClose = () => {
        if (props.vengo === "PedidosCli") {
            props.addPedido(false);
            props.tabla(true);
        } else {
            props.addPedido(false);
            props.tabla(true);
        }
    };

    return (
        <div style={{ position: "relative" }}>
            {props.vengo !== "PedidosCli" && (
                <>
                    <Title
                        titulo={
                            props.datosCli.sisven_id
                                ? `Nuevo Pedido: ${props.datosCli.razon_social} (${props.datosCli.sisven_id})`
                                : `Nuevo Pedido: ${props.datosCli.razon_social} `
                        }
                        handleClose={() => {
                            props.addPedido(false);
                            props.tabla(true);
                        }}
                    />
                    <BarraDatosPedidoList
                        tksSinCap={tksSinCap}
                        capMaxKg={capMaxKg}
                        kgCarga={kgCarga}
                        sucursal={props.datosCli.sucursal}
                        condicionPago={props.datosCli.condicion}
                        precioIva={precioIva}
                        precionormal={precionormal}
                        segmento={props.datosCli.segmento}
                        segmentos={segmentos}
                        datosCli={props.datosCli}
                        getPrecios={getPrecios}
                        segSelected={segSelected}
                        setSegselectd={setSegselectd}
                        condSelected={condSelected}
                        setcondSelected={setcondSelected}
                        condicion={props.datosCli.condicion}
                        condiciones={condiciones}
                    />
                </>
            )}

            {tksSinCap.length !== 0 || tksSinPHOVencida.length !== 0 ? (
                <AlertWButtonCapYPH
                    tksSinCap={tksSinCap}
                    setTksSinCap={setTksSinCap}
                    tksSinPHOVencida={tksSinPHOVencida}
                    setTksSinPHOVencida={setTksSinPHOVencida}
                />
            ) : null}

            {tanqueSel &&
                tanqueSel.some((tanque) => !tanque.idbateria && tanque.capacidad === 0) && (
                    <Alerta
                        titulo={"Atención!"}
                        mensaje={
                            "Uno o más tanques seleccionados no tienen capacidad registrada. Solo será posible ingresar la cantidad de KG solicitados."
                        }
                        severity={"warning"}
                    />
                )}

            {datosPedido &&
                datosPedido.map((pedido, index) => {
                    const direccion = direcciones?.find((dir) => dir.id === pedido.id_direccionentrega);
                    const tanque = tanques?.find((t) => t.id_tanque === pedido.id_tanque);
                    const densidad = props.datosCli.id_empresa === 4 && direcciones && direccion
                        ? direccion?.densidad_autogas
                        : direccion?.densidad_hipergas;
                    const capacidadMaxima85 = tanque && direccion
                        ? (tanque.capacidad * 1 * 1000 * 0.85 * densidad).toFixed(2)
                        : "N/A";

                    return (
                        <div key={`${pedido.uuid_pedido}-${index}`} style={{ marginBottom: 35 }}>
                            <Container maxWidth="xl" sx={{ mt: 0.5 }} disableGutters>
                                <form onSubmit={guardarPedidos} autoComplete="off">
                                    <Accordion
                                        defaultExpanded={index === 0}
                                        expanded={expandedAccordion === index}
                                        onChange={handleAccordionChange(index)}
                                        sx={{
                                            border: "1px solid",
                                            borderColor: grey[300],
                                            borderRadius: "8px",
                                            mb: 2,
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            sx={{
                                                backgroundColor: "#E3F2FD",
                                                borderBottom: "1px solid",
                                                borderColor: grey[300],
                                                "& .MuiAccordionSummary-content": {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                },
                                            }}
                                        >
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Grid item xs={11}>
                                                    <Typography variant="subtitle1" fontWeight="bold">
                                                        Pedido {index + 1}{" "}
                                                        {direccion
                                                            ? `Lugar entrega: ${direccion.nombre_direccion}`
                                                            : "Dirección no asignada"}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        {tanque ? `Tanque: ${tanque.nro_serie}` : "Tanque no asignado"}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <IconButton
                                                        color="error"
                                                        onClick={(e) => {
                                                            deshacerAlmacenar(index);
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>

                                        <AccordionDetails sx={{ backgroundColor: "#F9FAFB", p: 2 }}>
                                            <Box>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={8}>
                                                        <Grid container spacing={2} mb={2}>
                                                            <Grid item xs={12} sm={9}>
                                                                <Autocomplete
                                                                    disableClearable
                                                                    disabled={!direcciones}
                                                                    options={direcciones}
                                                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                                                    value={
                                                                        direcciones.find(
                                                                            (d) => d.id === pedido.id_direccionentrega
                                                                        ) || null
                                                                    }
                                                                    onChange={(e, newValue) => {
                                                                        if (newValue) {
                                                                            actualizarPedido(
                                                                                index,
                                                                                "id_direccionentrega",
                                                                                newValue.id
                                                                            );
                                                                            actualizarPedido(
                                                                                index,
                                                                                "idsucursal_atiende",
                                                                                newValue.id_sucursal
                                                                            );
                                                                            setCambieDir(true);
                                                                            setDialogPrecioEspecialCerrado(false);
                                                                            setDialogListaPrecioCerrado(false);
                                                                            obtenerUltimoPedido(pedido.id_direccionentrega)
                                                                        }
                                                                    }}
                                                                    getOptionLabel={(direccion) =>
                                                                        direccion
                                                                            ? `${direccion.direccion_entrega} (${direccion.nombre_direccion})`
                                                                            : ""
                                                                    }
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            required
                                                                            {...params}
                                                                            style={style}
                                                                            size="small"
                                                                            label="Dirección"
                                                                            variant="outlined"
                                                                            focused
                                                                            color="primary"
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={3}>
                                                                <Button
                                                                    variant="outlined"
                                                                    size="small"
                                                                    onClick={() =>
                                                                        handleVerificarDomicilio(pedido.id_direccionentrega)
                                                                    }
                                                                    disabled={!direcciones || !pedido.id_direccionentrega}
                                                                    sx={{
                                                                        "&:hover": {
                                                                            backgroundColor: "#1565C0",
                                                                            color: "white",
                                                                            fontSize: 13,
                                                                        },
                                                                        height: "40px",
                                                                        fontSize: 13,
                                                                    }}
                                                                >
                                                                    Verificar Domicilio
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                        <Divider sx={{ mb: 2 }} />

                                                        <Grid container spacing={2} mb={2} alignItems="center">
                                                            <Grid item xs={12} sm={5}>
                                                                <Autocomplete
                                                                    disableClearable
                                                                    disabled={!pedido.id_direccionentrega}
                                                                    size="small"
                                                                    options={tanques}
                                                                    value={
                                                                        tanques.find((t) => t.id_tanque === pedido.id_tanque) || null
                                                                    }
                                                                    groupBy={(option) =>
                                                                        option.nombre ? `Batería: ${option.nombre}` : "Sin Batería"
                                                                    }
                                                                    onChange={(e, newValue) => {
                                                                        if (newValue) {
                                                                            actualizarPedido(index, "id_tanque", newValue.id_tanque);
                                                                            guardarTanqueSeleccionado(index, newValue.id_tanque);
                                                                            setcambieTanque(true);
                                                                            setDialogPrecioEspecialCerrado(false);
                                                                            setDialogListaPrecioCerrado(false);
                                                                            actualizarPedido(index, "id_bateria", newValue.idbateria);
                                                                        }
                                                                    }}
                                                                    getOptionLabel={(tanque) => tanque?.nro_serie || ""}
                                                                    getOptionDisabled={(tanque) => tanque.delivery_stop === 1}
                                                                    renderGroup={(params) => (
                                                                        <li
                                                                            key={params.key}
                                                                            style={{ paddingLeft: "15px", fontSize: 15, color: "black" }}
                                                                        >
                                                                            {params.group}
                                                                            <ul style={{ paddingLeft: "12px" }}>{params.children}</ul>
                                                                        </li>
                                                                    )}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            required
                                                                            {...params}
                                                                            size="small"
                                                                            label="Tanque"
                                                                            variant="outlined"
                                                                            style={style}
                                                                            focused
                                                                            color="primary"
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={1}>
                                                                <Tooltip title="Crear Nuevo Tanque En Domicilio">
                                                                    <IconButton
                                                                        disabled={!direcciones || !pedido.id_direccionentrega}
                                                                        color="primary"
                                                                        size="medium"
                                                                        onClick={() => handleAddTanque(pedido.id_direccionentrega)}
                                                                    >
                                                                        <AddCircleOutlineIcon fontSize="inherit" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Grid>
                                                            <Grid item xs={12} sm={3}>
                                                                {sucursales && (
                                                                    <FormControl fullWidth required focused color="primary">
                                                                        <InputLabel>Atendido por sucursal</InputLabel>
                                                                        <Select
                                                                            label="Atendido por sucursal"
                                                                            style={style}
                                                                            size="small"
                                                                            value={pedido.idsucursal_atiende}
                                                                            onChange={(e) =>
                                                                                actualizarPedido(index, "idsucursal_atiende", e.target.value)
                                                                            }
                                                                        >
                                                                            {sucursales.map((sucursal) => (
                                                                                <MenuItem key={sucursal.id} value={sucursal.id}>
                                                                                    {sucursal.nombre}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                )}
                                                            </Grid>

                                                        </Grid>

                                                        <Grid container spacing={2} alignItems="center">
                                                            <Grid item xs={12} sm={4}>
                                                                <TextField
                                                                    required={!pedido.cantidad && !pedido.porcentaje}
                                                                    disabled={!pedido.id_tanque} // Solo deshabilitado si no hay tanque
                                                                    onKeyPress={(event) => {
                                                                        if (!/[0-9]/.test(event.key)) {
                                                                            event.preventDefault();
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        maxLength: 5,
                                                                        readOnly: tanque && !tanque.nro_serie,
                                                                    }}
                                                                    error={
                                                                        pedido.cantidad &&
                                                                        tanque &&
                                                                        tanque.capacidad &&
                                                                        (pedido.cantidad * 1 === 0 ||
                                                                            (capMaxKg && pedido.cantidad * 1 > capMaxKg * 1))
                                                                    }
                                                                    helperText={
                                                                        pedido.cantidad &&
                                                                            tanque &&
                                                                            tanque.capacidad &&
                                                                            (pedido.cantidad * 1 === 0 ||
                                                                                (capMaxKg && pedido.cantidad * 1 > capMaxKg * 1))
                                                                            ? `Máximo: ${capMaxKg} kg. Mínimo: 0 kg.`
                                                                            : ""
                                                                    }
                                                                    placeholder="Cantidad en kg"
                                                                    name="cantidad"
                                                                    label="Cantidad en kg"
                                                                    onChange={(e) =>
                                                                        handleCantidadChange(index, "kg", e.target.value)
                                                                    }
                                                                    value={pedido.cantidad ? Math.floor(Number(pedido.cantidad)).toString() : ""}
                                                                    size="small"
                                                                    focused
                                                                    color="primary"
                                                                    style={style}
                                                                    fullWidth
                                                                />

                                                            </Grid>
                                                            <Grid item xs={12} sm={4}>
                                                                <TextField
                                                                    required={!pedido.cantidad && !pedido.porcentaje}
                                                                    disabled={!pedido.id_tanque} // Igual que el de kg
                                                                    onKeyPress={(event) => {
                                                                        if (!/[0-9]/.test(event.key)) {
                                                                            event.preventDefault();
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        maxLength: 5,
                                                                        readOnly: tanque && !tanque.nro_serie,
                                                                    }}
                                                                    error={
                                                                        pedido.cantidad &&
                                                                        tanque &&
                                                                        tanque.capacidad &&
                                                                        (pedido.cantidad * 1 === 0 ||
                                                                            (capMaxKg && pedido.cantidad * 1 > capMaxKg * 1))
                                                                    }
                                                                    helperText={
                                                                        pedido.cantidad &&
                                                                            tanque &&
                                                                            tanque.capacidad &&
                                                                            (pedido.cantidad * 1 === 0 ||
                                                                                (capMaxKg && pedido.cantidad * 1 > capMaxKg * 1))
                                                                            ? `Máximo: ${capMaxKg / densidad} lts. Mínimo: 0 lts.`
                                                                            : ""
                                                                    }
                                                                    placeholder="Cantidad en litros"
                                                                    name="cantidadLts"
                                                                    label="Cantidad en litros"
                                                                    onChange={(e) =>
                                                                        handleCantidadChange(index, "lts", e.target.value)
                                                                    }
                                                                    value={pedido.ltsacargar ? Math.floor(Number(pedido.ltsacargar)).toString() : ""}
                                                                    size="small"
                                                                    focused
                                                                    color="primary"
                                                                    style={style}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={4}>
                                                                <TextField
                                                                    required={!pedido.cantidad && !pedido.porcentaje}
                                                                    disabled={
                                                                        !pedido.id_tanque ||
                                                                        (tanque && !tanque.capacidad) ||
                                                                        (tanque && tanque.idbateria && tksSinCap && tksSinCap.length > 0)
                                                                    }
                                                                    onKeyPress={(event) => {
                                                                        if (!/[0-9]/.test(event.key)) {
                                                                            event.preventDefault();
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        maxLength: 2,
                                                                        readOnly: tanque && !tanque.nro_serie,
                                                                    }}
                                                                    placeholder="Porcentaje"
                                                                    name="porcentaje"
                                                                    error={pedido.porcentaje >= 85}
                                                                    helperText={pedido.porcentaje >= 85 ? "Debe ser menor al 85%" : null}
                                                                    label="Porcentaje"
                                                                    onChange={(e) => handleCantidadChange(index, "porcentaje", e.target.value)}
                                                                    value={pedido.porcentaje}
                                                                    size="small"
                                                                    style={style}
                                                                    fullWidth
                                                                    focused
                                                                    color="primary"
                                                                />
                                                            </Grid>
                                                            <Divider sx={{ mb: 2 }} />

                                                            <Grid item xs={12} sm={12}>
                                                                <TextField
                                                                    size="small"
                                                                    label="Observaciones"
                                                                    sx={{ marginBottom: 2 }}
                                                                    fullWidth
                                                                    value={pedido.observaciones || ""}
                                                                    onChange={(e) => actualizarPedido(index, "observaciones", e.target.value)}
                                                                    color="primary"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={10}>
                                                                <TextField
                                                                    size="small"
                                                                    label="Observaciones internas"
                                                                    sx={{ marginBottom: 2 }}
                                                                    fullWidth
                                                                    value={observaciones[index]?.observaciones_pedido || ""}
                                                                    onChange={(e) => actualizarObservaciones(index, e.target.value)}
                                                                    color="primary"
                                                                />
                                                            </Grid>

                                                            {precio && precio.length === 0 ? (
                                                                <Grid item xs={12} sm={2}>
                                                                    <Button
                                                                        variant="outlined"
                                                                        onClick={() =>
                                                                            props.datosCli.precio_especial === 1
                                                                                ? setdialogPrecioEspecial(true)
                                                                                : setdialogListaPrecio(true)
                                                                        }
                                                                        sx={{
                                                                            height: "40px",
                                                                            borderColor: "#1976D2",
                                                                            color: "#1976D2",
                                                                            "&:hover": { borderColor: "#1565C0", color: "#1565C0" },
                                                                        }}
                                                                    >
                                                                        Agregar precio
                                                                    </Button>
                                                                </Grid>
                                                            ) : null}
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={4} mt={1} mb={1}>
                                                        <Box
                                                            sx={{
                                                                backgroundColor: "#F5F5F5",
                                                                borderRadius: "8px",
                                                                p: 1,
                                                                border: "1px solid",
                                                                borderColor: grey[300],
                                                                mt: -2,
                                                            }}
                                                        >

                                                            <List dense>
                                                                <ListItem sx={{ py: 0.5 }}>
                                                                    <ListItemText>
                                                                        <strong>ÚLTIMO PEDIDO ENTREGADO: {props.datosCli && ultimoPedido[0]?.fecha_real_entrega ? moment(ultimoPedido[0]?.fecha_real_entrega).format("DD/MM/YYYY") : "-"}</strong>
                                                                    </ListItemText>
                                                                </ListItem>
                                                                <ListItem sx={{ py: 0.5 }}>
                                                                    <ListItemText
                                                                        primary="Cantidad a cargar:"
                                                                        secondary={
                                                                            pedido.kgacargar && pedido.ltsacargar
                                                                                ? `${Math.floor(Number(pedido.cantidad)).toString()} kg / ${Math.floor(Number(pedido.ltsacargar)).toString()} L`
                                                                                : "No calculada"
                                                                        }
                                                                    />
                                                                </ListItem>
                                                                <ListItem sx={{ py: 0.5 }}>
                                                                    <ListItemText
                                                                        primary={`Capacidad: ${tanque ? tanque.capacidad : "No registrada"
                                                                            } m³`}
                                                                    />
                                                                    {tanquesxbat?.length > 0 && (
                                                                        <Button
                                                                            variant="text"
                                                                            size="small"
                                                                            onClick={() => setShowModalCap(true)}
                                                                        >
                                                                            Ver Capacidades
                                                                        </Button>
                                                                    )}
                                                                </ListItem>
                                                                <ListItem sx={{ py: 0.5 }}>
                                                                    <ListItemText
                                                                        primary={`Cap máx (85%): ${tanque && tanque.idbateria === null
                                                                            ? capacidadMaxima85
                                                                            : capMaxKg
                                                                            } kg`}
                                                                    />
                                                                </ListItem>
                                                                <ListItem sx={{ py: 0.5 }}>
                                                                    <ListItemText
                                                                        primary={`Precio sin IVA: $${precionormal || 0}`}
                                                                    />
                                                                </ListItem>
                                                                <ListItem sx={{ py: 0.5 }}>
                                                                    <ListItemText
                                                                        primary={`Precio con IVA: $${precioIva || 0}`}
                                                                    />
                                                                </ListItem>
                                                                <ListItem sx={{ py: 0.5 }}>
                                                                    <Box
                                                                        display="flex"
                                                                        alignItems="center"
                                                                        justifyContent="space-between"
                                                                        width="100%"
                                                                    >
                                                                        <ListItemText primary="Pago anticipado:" />
                                                                        <FormControlLabel
                                                                            disabled={props.datosCli.facturacion_especial === 1}
                                                                            checked={pedido.mantiene_precio}
                                                                            onChange={(e) =>
                                                                                actualizarPedido(
                                                                                    index,
                                                                                    "mantiene_precio",
                                                                                    e.target.checked ? 1 : 0
                                                                                )
                                                                            }
                                                                            control={<Checkbox />}
                                                                            label=""
                                                                        />
                                                                    </Box>
                                                                </ListItem>
                                                            </List>
                                                        </Box>
                                                    </Grid>
                                                </Grid>

                                                <Divider sx={{ mb: 2 }} />


                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Box
                                        sx={{
                                            position: "fixed",
                                            bottom: 16,
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            mb: 3,
                                            mt: 2,
                                            display: "flex",
                                            gap: 2,
                                        }}
                                    >
                                        <Tooltip title="Añadir Pedido">
                                            <Fab
                                                color="primary"
                                                aria-label="add"
                                                onClick={handleAddAccordion}
                                                sx={{ width: 56, height: 56 }}
                                                disabled={!pedido.id_direccionentrega || !pedido.id_tanque || !pedido.idsucursal_atiende || !(pedido.cantidad || pedido.ltsacargar || pedido.porcentaje)}
                                            >
                                                <AddIcon />
                                            </Fab>
                                        </Tooltip>
                                        <Tooltip title="Guardar Pedidos">
                                            <Fab
                                                variant="contained"
                                                type="submit"
                                                color="success"
                                                disabled={
                                                    !props.datosCli.cuit || disbtn || !props.datosCli.id_sucursal
                                                }
                                                sx={{
                                                    width: 56,
                                                    height: 56,
                                                }}
                                            >
                                                <Save />
                                            </Fab>
                                        </Tooltip>
                                    </Box>
                                </form>
                            </Container>
                        </div>
                    );
                })}


            {showModalMapa ? (
                <VerificacionDomicilio
                    direccion={direccionSeleccionada}
                    open={showModalMapa}
                    setOpen={setShowModalMapa}
                    obtenerDirecciones={obtenerDirecciones}
                    setDireccion={(nuevaDireccion) => {
                        setDirecciones((prevDirecciones) =>
                            prevDirecciones.map((dir) =>
                                dir.id === nuevaDireccion.id ? nuevaDireccion : dir
                            )
                        );
                        setDireccionSeleccionada(nuevaDireccion);
                    }}
                />
            ) : null}

            {showAltaTanque ? (
                <FormTanqueRapido
                    datosCliente={props.datosCli}
                    datosPedido={datosPedido}
                    open={showAltaTanque}
                    setOpen={setShowAltaTanque}
                    direccion={direccionSeleccionada}
                    actualizar={(valor) => getTanques(valor)}
                    setTanque={setTanqueSel}
                />
            ) : null}

            {pedidoRepetido && pedidoRepetido.length > 0 ? (
                <ModalRepetido2
                    datosCliente={props.datosCli}
                    pedidoRepetido={pedidoRepetido}
                    setRepetido={setPedidoRepetido}
                    setTanque={(nuevotanque) => {
                        setTanqueSel((prevDirecciones) =>
                            prevDirecciones.map((t) =>
                                t.id_tanque === nuevotanque.id_tanque ? nuevotanque : t
                            )
                        );
                    }}
                />
            ) : null}

            {noPH && tanqueConPHVencida ? (
                <DialogPHVencida
                    title={`El tanque N° Serie: ${tanqueConPHVencida.nro_serie} no tiene vencimiento de prueba hidráulica registrada.`}
                    texto={"A continuación, puede registrar el vencimiento:"}
                    open={noPH}
                    setOpen={setNoPH}
                    tanque={tanqueSel}
                    setTanque={setTanqueSel}
                    setTanqueSel={setTanqueSel}
                    tanques={tanques}
                />
            ) : null}

            {PHVencida && tanqueConPHVencida ? (
                <DialogPHVencida
                    title={`La prueba hidráulica del tanque N° Serie: ${tanqueConPHVencida.nro_serie} venció el día ${moment(
                        tanqueConPHVencida.vto_pruebahidraulica
                    ).format("DD-MM-YYYY")}`}
                    texto={"A continuación, puede actualizar la fecha de vencimiento de prueba hidráulica."}
                    open={PHVencida}
                    setOpen={setPHVencida}
                    tanque={tanqueConPHVencida}
                    setTanque={setTanqueSel}
                    tanques={tanques}
                />
            ) : null}

            {dialogPrecioEspecial ? (
                <AddPrecioEspecialDireccion
                    open={dialogPrecioEspecial}
                    onClose={onCloseDialog}
                    setOpen={setdialogPrecioEspecial}
                    direccion={direccion}
                    datos={props.datosCli}
                    actualizar={getPrecios}
                    setDireccion={(nuevaDireccion) => {
                        setDirecciones((prevDirecciones) =>
                            prevDirecciones.map((dir) =>
                                dir.id === nuevaDireccion.id ? nuevaDireccion : dir
                            )
                        );
                    }}
                />
            ) : null}

            {dialogListaPrecio ? (
                <ModalAddlistaprecio
                    open={dialogListaPrecio}
                    onClose={handleCloseDialogListaPrecio}
                    setOpen={setdialogListaPrecio}
                    direccion={direccion}
                    datos={props.datosCli}
                    actualizar={getPrecios}
                    segmento={segmentos}
                    segSelected={segSelected}
                    setSegselectd={setSegselectd}
                    setDireccion={(nuevaDireccion) => {
                        setDirecciones((prevDirecciones) =>
                            prevDirecciones.map((dir) =>
                                dir.id === nuevaDireccion.id ? nuevaDireccion : dir
                            )
                        );
                    }}
                />
            ) : null}

            {modalCuit ? (
                <Sin_cuit
                    datos={props.datosCli}
                    setdatos={props.setDataCliente}
                    open={modalCuit}
                    setOpen={setmodalCuit}
                />
            ) : null}

            {showModalCap ? (
                <ModalCapacidades open={showModalCap} setOpen={setShowModalCap} tanquesxbat={tanquesxbat} />
            ) : null}

            {notificacion && notificacion.open ? (
                <Notify
                    mensaje={notificacion.mensaje}
                    open={notificacion.open}
                    color={notificacion.color}
                    handleClose={handleClose}
                    severity={notificacion.severity}
                />
            ) : null}
        </div>
    );
}

export default AddPedidosList;

//----- Component --------------------------------------------------------/
// Developer     : Candela Grosso
// Creation Date : 23/4/2025
// Version       : 1
// Description   : Este es un componente para cargar pedidos a un cliente a través de un formulario dinámico donde el usuario podrá cargar mas de uno a distintas direcciones o a distintos tanques... de la version original "Addpedidos4" la modificacion mas grande es esa- se agregó la opción pago anticipado, la posibilidad de ingresar tanto en kilos como en litros lo que se le va a entregar al cliente (aunque al momento de guardar, lo hace en kilos), observaciones internas que son para los usuarios de granel.
//Las observaciones van a estar relacionadas con un uuid porque la idea es poder poner 1 o mas segun sea necesario.-
//LO QUE FALTA: un campo donde ingresar el monto que el cliente quiere pagar y que calcule cuanto es
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//========================================================================/
  // const calcularPorcentajeDesdeCantidad = (valorIngresado, tanque, unidad = "kg") => {
    //     if (!direccion || !direccion.length) {
    //         console.error("La dirección no está definida o está vacía");
    //         return "";
    //     }

    //     const densidad = props.datosCli.id_empresa === 4
    //         ? direccion[0].densidad_autogas
    //         : direccion[0].densidad_hipergas;

    //     if (!densidad || densidad === 0) {
    //         console.error("La densidad no está definida correctamente:", densidad);
    //         return "";
    //     }

    //     if (!valorIngresado || isNaN(valorIngresado) || valorIngresado <= 0) {
    //         console.error("El valor ingresado no es válido:", valorIngresado);
    //         return "";
    //     }

    //     let capacidadUtilTotal = 0;

    //     if (tanque && tanque.idbateria) {
    //         if (!tanquesxbat || tanquesxbat.length === 0) {
    //             console.error("No se ha definido o no hay tanques en la batería.");
    //             return "";
    //         }

    //         capacidadUtilTotal = tanquesxbat
    //             .filter((item) => item.id_bateria === tanque.idbateria)
    //             .reduce((acumulador, item) => acumulador + item.capacidad * 1000 * 0.85, 0);
    //     } else if (tanque && tanque.capacidad) {
    //         capacidadUtilTotal = tanque.capacidad * 1000 * 0.85;
    //     } else {
    //         console.error("El tanque no tiene capacidad válida.");
    //         return "";
    //     }

    //     if (!capacidadUtilTotal || capacidadUtilTotal === 0) {
    //         console.error("Capacidad útil total inválida:", capacidadUtilTotal);
    //         return "";
    //     }

    //     // Si el valor ingresado está en litros, lo paso a kg
    //     let kg = unidad === "lts" ? valorIngresado * densidad : valorIngresado;

    //     const porcentaje = 1 - (kg / (capacidadUtilTotal * densidad));
    //     return Math.round(porcentaje * 100);
    // };